import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import { formatDate, getTodayDate } from "../../../../common/Validations";
import { useSelector } from "react-redux";

const LoadingAdviceDetails = () => {
  //Customer ID
  let customerID = useSelector((state) => state?.customer?.customerID);

  // console.log(">>customerID",customerID)
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [getLoadingAdviceDetails, setLoadingAdviceDetails] = useState([]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  let productDetailsCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row?.materialDescription}{" "}
          </p>
          <p className="m-0 p-0 text-success">{row?.materialCode} </p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Order Qty",
      id: "orderQuantityLoad",
      selector: (row) => row?.orderQuantityLoad || "",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {row?.orderQuantityLoad || "-"}
          </p>
          <p className="m-0 p-0 fw-bold">{row?.uOM || ""}</p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Load Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row?.orderQtyLoadConfirm}{" "}
          </p>
          <p className="m-0 p-0 text-success">{row?.uOM} </p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Date/time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.loadingDate)}{" "}
          </p>
          <p className="m-0 p-0 ">{row?.loadingTime} </p>
        </div>
      ),
      width: "160px",
    },

    {
      name: "Godown",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.godownAddress} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Shipping Address",
      id: "shippingAddress",
      selector: (row) => row?.shippingAddress || "",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row?.shippingAddress || "-"}
          </p>
          <p className="m-0 p-0 text-success">
            PIN: {row?.shippingPostalCode || "-"}
          </p>
        </div>
      ),
      width: "280px",
    },
    {
      name: "Truck No",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {row?.loadingTruckNoDescription}{" "}
          </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.loadingOtherTruckNo} </p>
        </div>
      ),
      width: "160px",
    },
    {
      name: "Driver Details",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.transporterDriverName} </p>
          <p className="m-0 p-0 ">{row?.transporterDriverContact} </p>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {formatDate(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
  ];

  let productDetailsData = getLoadingAdviceDetails[0]?.items;

  useEffect(() => {
    poDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const poDetails = async () => {
    let obj = {
      documentNumber: customerID,
    };
    await ItemServiceV2.getLoadingAdviceDetail(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        // console.log(">>PO data", item?.data);
        setLoadingAdviceDetails(item?.data);
      } else {
        setLoadingAdviceDetails([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Loading Advice Details</h2>
                <p className="subText"> Loading Advice Details </p>
              </Col>
            </Row>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Loading Advice Details
                      </span>
                      <span className="subHeaderTitle">
                        Loading Advice Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4 d-flex align-items-center">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Loading Nr"
                          id="documentNumber"
                          name="documentNumber"
                          // type="text"
                          value={
                            getLoadingAdviceDetails[0]?.documentNumber || ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created Date"
                          id="createdAt"
                          name="createdAt"
                          value={
                            formatDate(
                              getLoadingAdviceDetails[[0]]?.createdAt,
                            ) ||
                            getTodayDate("") ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created Date & Time"
                          id="createdAt"
                          name="createdAt"
                          value={
                            getLoadingAdviceDetails[0]?.createdAt
                              ? new Date(
                                  getLoadingAdviceDetails[0].createdAt,
                                ).toLocaleString("en-IN", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })
                              : ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Order Number"
                          id="orderSchedulingNr"
                          name="orderSchedulingNr"
                          type="text"
                          value={getLoadingAdviceDetails[0]?.orderSchedulingNr}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          id="customerName"
                          name="customerName"
                          type="text"
                          value={getLoadingAdviceDetails[0]?.customerName}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sales Officer"
                          id="createdByName"
                          name="createdByName"
                          type="text"
                          value={getLoadingAdviceDetails[0]?.createdByName}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created By"
                          id="createdByName"
                          name="createdByName"
                          type="text"
                          value={getLoadingAdviceDetails[0]?.createdByName}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          id="companyCodeDesc"
                          name="companyCodeDesc"
                          value={
                            getLoadingAdviceDetails[0]?.companyCodeDesc || ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoice Number"
                          id="invoiceNr"
                          name="invoiceNr"
                          value={getLoadingAdviceDetails[0]?.invoiceNr || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Accounts Voucher No & Status"
                          id="accountsVoucherDetails"
                          name="accountsVoucherDetails"
                          value={`${getLoadingAdviceDetails[0]?.accountsVoucherNo || ""} - ${
                            getLoadingAdviceDetails[0]?.accountsSyncStatus || ""
                          }`}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="e-Way Bill Status"
                          id="ewayBillDetails"
                          name="ewayBillDetails"
                          value={`${getLoadingAdviceDetails[0]?.ewayBill || ""} - ${
                            getLoadingAdviceDetails[0]?.e_WayBillStatus || ""
                          }`}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="e-Way Bill No"
                          id="e_WayBillNo"
                          name="e_WayBillNo"
                          value={getLoadingAdviceDetails[0]?.e_WayBillNo || ""}
                          disabled={true}
                        />
                      </Col>                     
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* table */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle">Line Items</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={productDetailsCol}
                          data={productDetailsData || []}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default LoadingAdviceDetails;
